import React from 'react'
import './footer.scss'
function Footer() {
  return (
    <div className="footer">
        <p>Created by Ivan Khizhnyak</p>
        <p>Just for portfolio</p>
        <p><a target="_blanc" href="https://github.com/IvanKhizhnyak">
          Check my GitHub for more
        </a></p>
        
        
    </div>
  )
}

export default Footer
